import React, { useContext, useMemo } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { SORT_ORDER } from 'globals.js';

// GLOBAL HELPERS
import { getListData, ListContext } from 'helpers/getListData';

// GLOBAL PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// STYLES
import styles from './forms.module.scss';

// MAIN COMPONENT
const Forms = () => {
  // CONTEXT
  const {
    data: { department = '' }
  } = useContext(ListContext) || {};

  // MEMOS
  const filterOptions = useMemo(() => department.split(','), [department]);

  // RENDER
  return (
    <Main>
      <Title documentTitle="Forms" title="Forms" />
      <Filters>
        {department && (
          <Filters.Select
            name="FormDepartment"
            placeholder="All Departments"
            options={filterOptions}
            className={styles.select}
          />
        )}
        <Filters.Search />
        <Filters.Reset />
      </Filters>
      <Table mobilePreviewKeys={['form_name', 'form_department']} showNumber />
    </Main>
  );
};

// EXPORT
export default getListData(Forms, {
  key: 'form',
  fetchArgs: {
    endpoint: ENDPOINTS.admin.forms.list,
    params: { isActive: 1 }
  },
  defaults: {
    sort: 'form_name',
    order: SORT_ORDER.ascending
  },
  persistFilters: false,
  columns: [
    {
      key: 'form_name',
      label: 'Form Name',
      component: ({ row: { original } = {}, value }) => (
        <Table.ExternalLink icon={false} label={value} value={original?.form_link_url} />
      )
    },
    {
      key: 'form_department',
      label: 'Department'
    },
    {
      key: 'form_description',
      label: 'Description',
      width: 200
    },
    {
      key: 'form_instructions_url',
      label: 'Instructions',
      component: Table.ExternalLink,
      sortable: false,
      width: 80
    },
    {
      key: 'form_link_url',
      label: 'Link',
      component: Table.ExternalLink,
      sortable: false,
      width: 80
    }
  ],
  sortable: true
});
